<mat-form-field
  class="form-tag-chip-list no-underline"
  data-cy="tag-input">
  <mat-chip-list #tagList>
    <mat-chip
      *ngFor="let tag of selectedTags; trackBy: trackByTagId"
      class="mat-tag-chip"
      [selectable]="false"
      [attr.data-cy]="'selected-tag-' + tag.id">
      <span *ngIf="tag.displayName">
        {{ tag.displayName }}
      </span>
      <mat-icon
        matChipRemove
        [attr.data-cy]="'remove-tag-' + tag.id"
        svgIcon="close"
        (click)="removeTag(tag.id)">
      </mat-icon>
    </mat-chip>
    <label class="tag-input-wrapper">
      <input
        ngModel
        #tagInput="ngModel"
        name="tagInput"
        [matAutocomplete]="autoTags"
        [matChipInputFor]="tagList"
        data-cy="tag-text-input" />
      <span
        *ngIf="!searchTerm"
        class="tag-placeholder"
        >{{ ("addTag" | i18n) || "Add Tag" }}</span
      >
    </label>
  </mat-chip-list>
  <mat-autocomplete
    #autoTags="matAutocomplete"
    (optionSelected)="addTag($event)">
    <mat-option
      *ngFor="let tag of filteredTags"
      [attr.data-cy]="'tag-option-' + tag.id"
      [value]="tag.id">
      {{ tag.displayName }}
      <mat-icon
        [attr.data-cy]="'tag-option-delete-' + tag.id"
        class="tag-delete-icon"
        svgIcon="delete-outline"
        (click)="destroyTag(tag.id, $event)">
      </mat-icon>
    </mat-option>
    <mat-option
      *ngIf="!filteredTags.length && searchTerm"
      data-cy="create-new-tag-option"
      [value]="newTagCreationString">
      {{ ("createNewTag" | i18n) || "Create new tag" | titlecase }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
